import {
  TOGGLE_PRODUCT,
  TOGGLE_CATEGORY,
  CHANGE_PRODUCT_FORM_QTTY,
  SET_CATEGORIES,
  SET_MENU_DATA,
  CLEAR_PRODUCTS_SELECTED,
  CLEAR_NEW_MENU_CATEGORIES,
} from './actions';
import {
  toggleProduct,
  toggleCategory,
  changeQuantity,
  clearProductsSelection,
} from '../../helpers/products';

const initialState = {
  categories: [],
  menu: {},
};

export default function newMenu(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_PRODUCT:
      return {
        ...state,
        categories: toggleProduct({
          categories: state.categories,
          categoryId: action.categoryId,
          productId: action.productId,
        }),
      };
    case TOGGLE_CATEGORY:
      return {
        ...state,
        categories: toggleCategory({
          categoryId: action.categoryId,
          categories: state.categories,
        }),
      };
    case CHANGE_PRODUCT_FORM_QTTY:
      return {
        ...state,
        categories: changeQuantity({
          categories: state.categories,
          categoryId: action.categoryId,
          productId: action.productId,
          quantity: action.quantity,
        }),
      };
    case SET_CATEGORIES:
      return {
        ...state,
        categories: action.categories,
      };
    case SET_MENU_DATA:
      return {
        ...state,
        menu: action.menu,
      };
    case CLEAR_PRODUCTS_SELECTED:
      return {
        ...state,
        categories: clearProductsSelection(state.categories),
      };
    case CLEAR_NEW_MENU_CATEGORIES:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/newMenu/reducer.js